<template>
  <TaxInvoicePrint
    v-if="invoiceData"
    :invoice-data="invoiceData"
    :paper-size="paperSize"
    :document-labels="quotationLabels"
  />
</template>

<script setup>
import { computed } from 'vue'
import TaxInvoicePrint from './TaxInvoicePrint.vue'

const props = defineProps({
  quotationData: {
    type: Object,
    required: true,
  },
  businessData: {
    type: Object,
    default: () => ({}),
  },
  customerData: {
    type: Object,
    default: () => ({}),
  },
  bankAccounts: {
    type: Array,
    default: () => [],
  },
  paperSize: {
    type: String,
    default: 'A4',
  },
})

const quotationLabels = {
  numberLabel: 'Quotation No.',
  dateLabel: 'Quotation Date',
  title: 'Quotation / Estimate',
  amountLabel: 'Quotation Amount',
  receiverHeader: 'Details of Receiver / Billing Address',
  consigneeHeader: 'Details of Consignee / Shipping Address',
  showCompliance: false,
}

const invoiceData = computed(() => {
  const quotation = props.quotationData
  if (!quotation) return null

  return {
    business_name: props.businessData?.name || 'OnePlaceHQ Billing',
    business_address: props.businessData?.address,
    business_phone: props.businessData?.phone,
    business_email: props.businessData?.email,
    business_gstin: props.businessData?.gstin,
    business_state: props.businessData?.state_code,

    customer_name: props.customerData?.name || quotation.customer_name || 'Walk-in Customer',
    customer_address: props.customerData?.address,
    customer_phone: props.customerData?.phone,
    customer_email: props.customerData?.email,
    customer_gstin: props.customerData?.gstin,
    customer_state_code: props.customerData?.state_code,

    invoice_number: quotation.quotation_number,
    invoice_date: quotation.quotation_date,
    sale_type: '',
    subtotal: quotation.subtotal,
    discount_type: quotation.discount_type,
    discount_value: quotation.discount_value,
    discount_amount: quotation.discount_amount,
    cgst_amount: quotation.cgst_amount,
    sgst_amount: quotation.sgst_amount,
    igst_amount: quotation.igst_amount,
    total_tax_amount: quotation.total_tax_amount,
    total_amount: quotation.total_amount,
    loyalty_discount_amount: 0,
    bank_accounts: props.bankAccounts,
    signature_enabled: false,
    items: quotation.items || [],
  }
})
</script>

<style>
.quotation-print-preview {
  max-height: 80vh;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  padding: 16px 0;
  background: #f6f7f9;
}

.quotation-print-preview .tax-invoice-pages {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.quotation-print-preview .tax-invoice-print {
  box-shadow: 0 2px 10px rgba(17, 24, 39, 0.16);
}

@media print {
  body.printing-quotation #app {
    display: none !important;
  }

  body.printing-quotation .intercom-modal-overlay {
    position: static !important;
    display: block !important;
    overflow: visible !important;
    padding: 0 !important;
    background: #fff !important;
  }

  body.printing-quotation .intercom-modal {
    width: auto !important;
    max-width: none !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  body.printing-quotation .intercom-modal-header,
  body.printing-quotation .intercom-modal-footer {
    display: none !important;
  }

  body.printing-quotation .intercom-modal-body {
    overflow: visible !important;
    padding: 0 !important;
  }

  body.printing-quotation .quotation-print-preview {
    display: block !important;
    max-height: none !important;
    overflow: visible !important;
    padding: 0 !important;
    background: #fff !important;
  }

  body.printing-quotation .quotation-print-preview .tax-invoice-pages {
    display: block !important;
  }

  body.printing-quotation .quotation-print-preview .tax-invoice-print {
    box-shadow: none !important;
  }
}
</style>
